import React, { useState, useEffect, useRef } from "react";
import TextFieldGroup from "../../commons/TextFieldGroup";
import Searchbar from "../../commons/Searchbar";

import {
  Layout,
  Breadcrumb,
  Form,
  Table,
  Row,
  Col,
  Button,
  Divider,
  message,
} from "antd";

import {
  formItemLayout,
  tailFormItemLayout,
  smallFormItemLayout,
  smallTailFormItemLayout,
} from "./../../utils/Layouts";
import {
  EditOutlined,
  CloseOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import isEmpty from "../../validation/is-empty";
import { useSelector } from "react-redux";
import {
  edit,
  onDelete,
  onSubmit,
  onSearch,
  onChange,
  onChangeSetting,
} from "../../utils/form_utilities";
import ReportHeading from "../../utils/ReportHeading";
import moment from "moment";
import RangeDatePickerFieldGroup from "../../commons/RangeDatePickerFieldGroup";
import axios from "axios";
import numberFormat from "../../utils/numberFormat";
import { addKeysToArray } from "../../utils/utilities";
import round from "../../utils/round";
import { sumBy } from "lodash";
import ReactToPrint from "react-to-print";
import numberFormatInt from "../../utils/numberFormatInt";

const { Content } = Layout;

const url = "/api/account-settings/";
const title = "Inventory Adjustments History";

const initialValues = {
  period_covered: [moment().startOf("month"), moment().endOf("month")],
};
export default function AccountSettingsForm() {
  const [errors, setErrors] = useState({});
  const [records, setRecords] = useState([]);
  const auth = useSelector((state) => state.auth);
  const [state, setState] = useState(initialValues);

  return (
    <Content className="content-padding">
      <div className="columns is-marginless">
        <div className="column">
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Reports</Breadcrumb.Item>
            <Breadcrumb.Item>{title}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <div style={{ background: "#fff", padding: 24, minHeight: 280 }}>
        <span className="module-title">{title}</span>
        <Divider />
        <Row>
          <Col span={12}>
            <TextFieldGroup
              label="Default SRP"
              name="srp"
              type="number"
              error={errors.srp}
              formItemLayout={smallFormItemLayout}
              value={state.srp}
              onChange={(e) => {
                onChange({
                  key: "srp",
                  value: e.target.value,
                  setState,
                });
              }}
              onPressEnter={() => {
                onChangeSetting({
                  key: "srp",
                  value: parseFloat(state.srp),
                });
                message.success("Setting Field Updated");
              }}
            />
          </Col>
        </Row>
      </div>
    </Content>
  );
}
